import React from 'react';

const StatsSkeleton = () => {
  return (
    <div className="bg-crystal-white border border-silver-mist shadow-minimal overflow-hidden animate-pulse-slow">
      <div className="p-8">
        <div className="flex items-start space-x-6">
          <div className="flex-shrink-0">
            <div className="h-8 w-8 bg-steel/20"></div>
          </div>
          <div className="flex-1 space-y-4">
            <div className="h-3 bg-steel/15 w-24"></div>
            <div className="h-6 bg-steel/20 w-16"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsSkeleton;
